import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { Link, useLocation } from 'react-router-dom';
import Logo from '..//..//assets/logo.jpg';
import LogoRound from '..//..//assets/round.jpg';
import { useTheme } from '../../contexts/ThemeContext';

import '../Navbar/Navbar.css';
import { FaBars, FaTimes, FaSun, FaMoon, FaInstagram, FaPhone, FaEnvelope } from 'react-icons/fa';

const NavbarContainer = styled.section`
  backdrop-filter: blur(20px);
  border-bottom: 1px solid var(--border-primary);
  transition: all 0.3s ease;
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 9999;
`;

const NavbarHeader = styled.div`
  @media (max-width: 550px) {
    justify-content: space-around !important;
  }
`;

const Nav = styled.nav``;

const NavUl = styled.ul`
  padding-left: 0px;
`;

const NavLi = styled.li`
  display: inline-block;
  list-style-type: none;
  margin: 0 5px;
`;

const ThemeToggle = styled.button`
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-left: 1rem;
  color: var(--text-primary);

  &:hover {
    background: var(--bg-tertiary);
    transform: scale(1.05);
  }

  @media (max-width: 992px) {
    margin-left: 0.5rem;
  }
`;

function Navbar() {
  const [isopen, setisopen] = useState(false);
  const { theme, toggleTheme } = useTheme();
  
  const handleToggle = () => {
    setisopen(!isopen);
    // Control body scroll when mobile menu is open
    if (!isopen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  };

  // Close menu and restore scroll when component unmounts or menu closes
  useEffect(() => {
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  // Close menu when clicking outside or on menu items
  const closeMenu = () => {
    setisopen(false);
    document.body.style.overflow = 'unset';
  };

  const location = useLocation();
  const [scroll, setScroll] = useState(false);
  useEffect(() => {
    window.addEventListener('scroll', () => {
      window.scrollY > 200 ? setScroll(true) : setScroll(false);
    });
  }, []);

  return (
    <div className='position-relative' style={{ zIndex: 9999 }}>
      <NavbarContainer
        className={`${
          scroll ? 'after-scroll ' : 'before-scroll'
        } navbar fixed-top navbar-expand-lg navbar-container `}
      >
        <div className='container-fluid'>
          <div className='d-flex justify-content-between align-items-center'>
            <div>
              <Link
                className='navbar-left'
                to='/'
                style={{ textDecoration: 'none' }}
              >
                <img
                  src={Logo}
                  className='mx-sm-2 mx-1 logo'
                  style={{
                    width: `${scroll ? '50px' : '60px'}`,
                    height: `${scroll ? '50px' : '60px'}`,
                    transition: 'width 0.5s ease, height 0.5s ease',
                  }}
                  alt='logo'
                  loading='lazy'
                />
              </Link>
            </div>
            <span
              className='company-text px-sm-2 px-0'
              style={{
                fontSize: `${scroll ? '16px' : '20px'}`,
                transition: 'width 0.5s ease, height 0.5s ease',
              }}
            >
              Amruth Build Products
            </span>
          </div>

          {/* Desktop Navigation */}
          <div className='d-none d-lg-flex'>
            <NavUl className='navbar-nav ms-auto d-flex align-items-center'>
              <NavLi className='nav-item'>
                <Link
                  className={`nav-link ${
                    location.pathname === '/' ? 'active' : ''
                  }`}
                  to='/'
                >
                  Home
                </Link>
              </NavLi>
              <NavLi className='nav-item'>
                <Link
                  className={`nav-link ${
                    location.pathname === '/about' ? 'active' : ''
                  }`}
                  to='/about'
                >
                  About
                </Link>
              </NavLi>
              <NavLi className='nav-item'>
                <Link
                  className={`nav-link ${
                    location.pathname === '/products' ? 'active' : ''
                  }`}
                  to='/products'
                >
                  Products
                </Link>
              </NavLi>
              <NavLi className='nav-item'>
                <Link
                  className={`nav-link ${
                    location.pathname === '/projects' ? 'active' : ''
                  }`}
                  to='/projects'
                >
                  Projects
                </Link>
              </NavLi>
              <NavLi className='nav-item'>
                <Link
                  className={`nav-link ${
                    location.pathname === '/services' ? 'active' : ''
                  }`}
                  to='/services'
                >
                  Services
                </Link>
              </NavLi>
              <NavLi className='nav-item'>
                <Link
                  className='btn btn-primary ms-2 contact-btn'
                  to='/contact'
                  style={{ color: 'black' }}
                >
                  Contact Us
                </Link>
              </NavLi>
              {/* <NavLi className='nav-item'>
                <ThemeToggle onClick={toggleTheme} aria-label='Toggle theme'>
                  {theme === 'light' ? <FaMoon size={18} /> : <FaSun size={18} />}
                </ThemeToggle>
              </NavLi> */}
            </NavUl>
          </div>

          {/* Mobile Menu Toggle & Theme Toggle */}
          <div className='d-lg-none d-flex align-items-center gap-2'>
            {/* <ThemeToggle 
              className='mobile-theme-toggle'
              onClick={toggleTheme} 
              aria-label='Toggle theme'
            >
              {theme === 'light' ? <FaMoon size={16} /> : <FaSun size={16} />}
            </ThemeToggle> */}
            <button
              className='mobile-menu-toggle'
              onClick={handleToggle}
              aria-label='Toggle navigation'
            >
              {isopen ? <FaTimes size={20} /> : <FaBars size={20} />}
            </button>
          </div>
        </div>
      </NavbarContainer>

      {/* Mobile Menu Overlay */}
      <div className={`mobile-menu-overlay ${isopen ? 'active' : ''}`}>
        <div className='mobile-menu-backdrop' onClick={closeMenu}></div>
        <div className='mobile-menu-content'>
          {/* Navigation Links */}
          <NavUl className='mobile-nav-list'>
            <NavLi className='mobile-nav-item' style={{ '--delay': '0.1s' }}>
              <Link
                className={`mobile-nav-link ${
                  location.pathname === '/' ? 'active' : ''
                }`}
                to='/'
                onClick={closeMenu}
              >
                Home
              </Link>
            </NavLi>
            <NavLi className='mobile-nav-item' style={{ '--delay': '0.15s' }}>
              <Link
                className={`mobile-nav-link ${
                  location.pathname === '/about' ? 'active' : ''
                }`}
                to='/about'
                onClick={closeMenu}
              >
                About
              </Link>
            </NavLi>
            <NavLi className='mobile-nav-item' style={{ '--delay': '0.2s' }}>
              <Link
                className={`mobile-nav-link ${
                  location.pathname === '/products' ? 'active' : ''
                }`}
                to='/products'
                onClick={closeMenu}
              >
                Products
              </Link>
            </NavLi>
            <NavLi className='mobile-nav-item' style={{ '--delay': '0.25s' }}>
              <Link
                className={`mobile-nav-link ${
                  location.pathname === '/projects' ? 'active' : ''
                }`}
                to='/projects'
                onClick={closeMenu}
              >
                Projects
              </Link>
            </NavLi>
            <NavLi className='mobile-nav-item' style={{ '--delay': '0.3s' }}>
              <Link
                className={`mobile-nav-link ${
                  location.pathname === '/services' ? 'active' : ''
                }`}
                to='/services'
                onClick={closeMenu}
              >
                Services
              </Link>
            </NavLi>
          </NavUl>

          {/* Mobile Menu Footer */}
          <div className='mobile-menu-footer'>
            <Link
              className='mobile-contact-btn'
              to='/contact'
              onClick={closeMenu}
            >
              Contact Us
            </Link>
            
            <div className='mobile-menu-divider'></div>
            
            <div className='mobile-menu-info'>
              <p className='mobile-menu-tagline'>Building Excellence Together</p>
              <div className='mobile-social-links'>
                <a href="mailto:info@amruthbuild.com" className='social-link'>
                  <FaEnvelope />
                </a>
                <a href="tel:+919876543210" className='social-link'>
                  <FaPhone />
                </a>
                <a href="https://instagram.com/amruthbuild" className='social-link'>
                  <FaInstagram />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Navbar;
